import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  inputPlaceholder: {
    key: 'ZaiHero-input-placeholder',
    defaultValue: 'Pergunte à ZAI sobre qualquer coisa relacionada à sua marca, tópicos, tendências, concorrentes, ...',
  },
})
